// update state
const setContextTemplateIdAction = (payload) => {
    return {
        type: "CONTEXTTEMPLATEID",
        payload
    }
}

export default setContextTemplateIdAction;


// WEBPACK FOOTER //
// ./src/actions/setContextTemplateIdAction.js